export const TERM_TYPE = {
  CONTRIBUTION_TERMS: 'contributionTerms',
} as const;

export type TermType = (typeof TERM_TYPE)[keyof typeof TERM_TYPE];

export type TermDto = {
  id: string;
  type: TermType;
  version: number;
  text: string;
  createdBy: string;
  createdAt: string;
  publishedBy?: string;
  publishedAt?: string;
  deletedAt?: string;
  deletedBy?: string;
};

export type GetTermsResponseDto = {
  terms: TermDto[];
};

export type CreateTermRequestDto = {
  type: TermType;
  text: string;
};

export type PublishTermRequestDto = {
  termType: TermType;
};
